import {DeliveryProvider} from "../../../../../services/exports/Constants";

export default {
  text: {
    [DeliveryProvider.Standalone]: '<strong>Bestelle hier</strong> statt anderen Plattformen für kostenlose Rewards, schnellsten Service, und hilf uns, <strong>{{savings}}</strong> bei jeder Bestellung zu sparen.',
    [DeliveryProvider.FirstDelivery]: '<strong>Lieferung & Abholung:</strong> Bestelle hier statt anderen Plattformen für kostenlose Rewards, schnellsten Service, und hilf uns, <strong>{{savings}}</strong> bei jeder Bestellung zu sparen.',
  },
};